/*
 * © 2026 eggs unimedia GmbH
 * Coded with love 💛
 */

import React from 'react' // eslint-disable-line no-unused-vars
import Text from './Text'
import Button from './Button'
import Icon from './Icon'

/**
 * EGGS ErrorFallback Component
 * Design-System-konforme Fehleranzeige für Error Boundaries
 *
 * @param {Object} props
 * @param {Error} props.error - The caught error
 * @param {Function} props.resetErrorBoundary - Reset function from react-error-boundary
 * @param {'page'|'section'} [props.variant='page'] - Display variant
 * @param {string} [props.className] - Additional CSS classes
 */
export default function ErrorFallback({
  error: _error,
  resetErrorBoundary,
  variant = 'page',
  className = '',
}) {
  if (variant === 'section') {
    return (
      <div
        className={`flex items-center gap-3 p-4 rounded-lg border border-yellow-200 bg-yellow-50 ${className}`}
        role="alert"
      >
        <Icon name="alert-circle" size={20} color="#FFC107" />
        <div className="flex-1">
          <Text
            type="Body"
            variant="sm"
            weight="Strong"
            className="text-yellow-800"
          >
            Etwas ist schiefgelaufen
          </Text>
          <Text type="Body" variant="xs" className="text-yellow-700">
            Dieser Bereich ist gerade nicht verfügbar.
          </Text>
        </div>
        {resetErrorBoundary && (
          <Button variant="outline" size="sm" onClick={resetErrorBoundary}>
            Erneut versuchen
          </Button>
        )}
      </div>
    )
  }

  return (
    <div
      className={`flex flex-col items-center justify-center min-h-[50vh] px-4 text-center ${className}`}
      role="alert"
    >
      <Icon name="alert-circle" size={48} color="#DC3545" />
      <Text type="Heading" variant="h3" className="mt-4 text-eggs-dark">
        Etwas ist schiefgelaufen
      </Text>
      <Text type="Body" variant="Base" className="mt-2 text-gray-600 max-w-md">
        Keine Sorge – versuch es einfach nochmal. Falls das Problem bestehen
        bleibt, lade die Seite neu.
      </Text>
      {resetErrorBoundary && (
        <Button
          variant="brand"
          size="md"
          onClick={resetErrorBoundary}
          className="mt-6"
        >
          Erneut versuchen
        </Button>
      )}
    </div>
  )
}
